var _rect, _path, _path2, _rect2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F9F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 14.9971V19.9992",
    stroke: "#9E77ED",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0026 29.0018V21.9989C33.0026 20.8939 32.1068 19.998 31.0018 19.998H16.996C15.8909 19.998 14.9951 20.8939 14.9951 21.9989V29.0018",
    stroke: "#9E77ED",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9971,
    y: 26.001,
    width: 5.00208,
    height: 3.00125,
    stroke: "#9E77ED",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0018 33.0046H17.2461C16.0029 33.0046 14.9951 31.9968 14.9951 30.7536V20.4994C14.9948 19.9591 15.1044 19.4243 15.3173 18.9277L16.4117 16.3636C16.7656 15.5346 17.5802 14.9968 18.4816 14.9971H29.5152C30.4166 14.9968 31.2311 15.5346 31.585 16.3636L32.6855 18.9277C32.8965 19.4247 33.0044 19.9594 33.0026 20.4994V31.0037C33.0026 32.1088 32.1068 33.0046 31.0018 33.0046Z",
    stroke: "#9E77ED",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.cde91e9505712ba866af55e97c0a8d1e.svg";
export { ForwardRef as ReactComponent };